var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectPurseCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 52,
    height: 53,
    rx: 6.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 52,
    height: 53,
    rx: 6.5,
    stroke: "#FF8027",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.76 26.655C40.5949 25.6527 40.0805 24.7411 39.3078 24.0816C38.5352 23.4221 37.5541 23.0573 36.5383 23.0517H33.105V21.385C33.105 20.0313 32.5672 18.733 31.61 17.7758C30.6528 16.8186 29.3545 16.2808 28.0008 16.2808C26.6471 16.2808 25.3488 16.8186 24.3916 17.7758C23.4344 18.733 22.8966 20.0313 22.8966 21.385V23.0517H19.4633C18.4475 23.0573 17.4664 23.4221 16.6938 24.0816C15.9211 24.7411 15.4067 25.6527 15.2416 26.655L13 39.7183H43L40.76 26.655ZM24.77 21.385C24.77 20.5284 25.1103 19.7068 25.716 19.101C26.3218 18.4953 27.1433 18.155 28 18.155C28.8566 18.155 29.6782 18.4953 30.2839 19.101C30.8897 19.7068 31.23 20.5284 31.23 21.385V23.0517H24.77V21.385ZM17.0883 26.9717C17.1782 26.4052 17.466 25.8889 17.9005 25.5145C18.335 25.1401 18.8881 24.9319 19.4616 24.9267H22.895V31.1417H24.77V24.9267H31.2283V31.1417H33.1033V24.9267H36.5366C37.1104 24.9315 37.6639 25.1397 38.0988 25.5141C38.5336 25.8885 38.8216 26.405 38.9116 26.9717L40.775 37.8433H15.2233L17.0883 26.9717Z",
    fill: "#FF8027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectPurseCritical);
export default __webpack_public_path__ + "static/media/object-purse-critical.84c49dda2714e00e20a5f10163f346b7.svg";
export { ForwardRef as ReactComponent };